import { IReferenceData } from '../interfaces/form/reference-data.model';

export interface PlacementFilterConstants {
  siteTypes: {
    text: string;
    control: string;
    items: { control: string; text: string }[];
  }[];
  siteTypesPreschool: {
    text: string;
    control: string;
    items: { control: string; text: string }[];
  }[];
  schoolTypes: string[];
  classTypes: string[];
  programList: IReferenceData[];
}

export const PLACEMENT_FILTER_CONSTANTS: PlacementFilterConstants = {
  siteTypes: [
    {
      control: 'isShowClassesSupportStudentGrade',
      text: 'Show classes that support student’s grade',
      items: [],
    },
    {
      control: 'restrictStudentsDistrict',
      text: 'Restrict to student’s district',
      items: [],
    },
    {
      control: 'isAccessibleSchoolRequired',
      text: 'Accessible school required',
      items: [],
    },
  ],
  siteTypesPreschool: [
    {
      text: 'Show classes with',
      control: 'noSeat',
      items: [
        { control: 'showByAvailableSeats', text: 'Available seats' },
        { control: 'noSeats', text: 'No seats + no overenrollment' },
        { control: 'varianceOne', text: 'No seats + overenrollment (+1)' },
        { control: 'varianceTwo', text: 'No seats + overenrollment (+2)' },
      ],
    },
    {
      control: 'restrictStudentsDistrict',
      text: 'Restrict to student’s district',
      items: [],
    },
    {
      control: 'isAccessibleSchoolRequired',
      text: 'Accessible school required',
      items: [],
    },
  ],
  schoolTypes: [
    'Paraprofessional Recommended',
    'Nurse Recommended',
    'Restrict to student’s district',
    'Accessible School Required',
    'Sort schools by Building Accessibility Profile',
  ],
  classTypes: [
    'Deferred/Future Class',
    'Restrict 3 year age range',
    'Restrict math level',
    'Restrict reading level',
    'Show classes with available seats',
    'Show classes for student’s language',
    'Show classes that support student’s grade',
  ],
  programList: [
    {
      id: 22,
      description: 'Special Class',
      sortOrder: 5,
      value: 'SC',
      indicator: null,
      extDescr: 'NULL',
    },
    {
      id: 23,
      description: 'Special Class Integrated Setting (SCIS)',
      sortOrder: 5,
      value: 'SCIS',
      indicator: null,
      extDescr: 'NULL',
    },
    {
      id: 24,
      description: 'Special Education Teacher Support Services',
      sortOrder: 5,
      value: 'SETSS',
      indicator: null,
      extDescr: 'NULL',
    },
    {
      id: 25,
      description: 'Integrated Co-Teaching Services',
      sortOrder: 5,
      value: 'ICT',
      indicator: null,
      extDescr: 'NULL',
    },
  ],
};
